import { IonSpinner } from '@ionic/react';
import classNames from 'classnames';
import { FullPost } from 'model';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../App';
import { useAddPostImageMutation } from '../api/PostApi';
import { useImageUpload } from '../hooks/useImageUpload';
import { LoginState } from '../state/loginSlice';
import { IconButton } from './IconButton';
import { IconCamera } from './QuirkIcons';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';

export const UploadImageButton: React.FC<{ post: FullPost; size?: string; iconRight?: boolean; label?: string }> = ({
	post,
	iconRight,
	label = 'Upload Image'
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const { loading, uploadImage } = useImageUpload(post, useAddPostImageMutation);

	const imageHandler = () => {
		inputRef.current?.click();
	};

	return (
		<>
			{post.author === state.user._id && (
				<>
					<input
						type="file"
						name="imageUpload"
						ref={inputRef}
						className="hiddenElement"
						onChange={e => uploadImage(e)}
					/>

					<IconButton
						label={label}
						icon={
							<span className="iconCircle">
								{loading ? (
									<IonSpinner
										className={classNames(sharedStyles.contrastColor, sharedStyles.controlIcon)}
									/>
								) : (
									<IconCamera />
								)}
							</span>
						}
						onClick={imageHandler}
						iconRight={iconRight}
					/>
				</>
			)}
		</>
	);
};
